import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class DebugService extends Service {
  @tracked isEnabled = false;

  toggle() {
    this.isEnabled = !this.isEnabled;
  }

  enable() {
    this.isEnabled = true;
  }

  disable() {
    this.isEnabled = false;
  }
}
